import { type PropsWithChildren } from 'react'

import Header from 'apps/employer_renewals/components/Header'
import PageContainer from 'apps/employer_renewals/components/layout/PageContainer'
import FinalizedContent from 'apps/employer_renewals/pages/allowances/complete/FinalizedContent'
import PreliminaryContent from 'apps/employer_renewals/pages/allowances/complete/PreliminaryContent'
import { useHasFinalizedPricing } from 'apps/employer_renewals/providers/EmployerProvider'
import { useConfetti } from 'components/hooks/useConfetti'

type Props = {
  reviewingAcceptedQuote?: boolean
}

type PageCopy = {
  heading: string
}

const preliminaryCopy: PageCopy = {
  heading: "You're all set!"
}

const finalizedCopy: PageCopy = {
  heading: 'Thanks for confirming your 2026 renewal!',
}

export default function CompletePage ({ reviewingAcceptedQuote, children }: PropsWithChildren<Props>) {
  useConfetti({ trigger: !reviewingAcceptedQuote })
  const hasFinalizedPricing = useHasFinalizedPricing()

  const pageCopy = hasFinalizedPricing ? finalizedCopy : preliminaryCopy

  return (
    <PageContainer maxWidth='md'>
      <Header
        heading={pageCopy.heading}
        textAlign='left'
      />
      {children}
      {hasFinalizedPricing
        ? <FinalizedContent showBackToDashboardButton={!reviewingAcceptedQuote} />
        : <PreliminaryContent showBackToDashboardButton={!reviewingAcceptedQuote} />}
    </PageContainer>
  )
}
